import { ComponentWithAs, IconProps } from '@chakra-ui/react';

import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../common/constants';
import { SEHomeEthernetIcon, SEHomeEVChargerIcon, SEHomeWifiIcon } from '../../../styles/custom-icons';
import { HardwareConnection, VisibleHardwareType } from './types';

export const HARDWARE_TYPE_TO_UI_CONFIG: Record<
  VisibleHardwareType,
  { icon: ComponentWithAs<'svg', IconProps>; title: string }
> = {
  EV_CHARGER: { icon: SEHomeEVChargerIcon, title: 'EV Charger' },
};

export const HARDWARE_CONNECTION_TO_UI_CONFIG: Record<
  'WIFI' | 'ETHERNET',
  { icon: ComponentWithAs<'svg', IconProps>; title: string }
> = {
  WIFI: { icon: SEHomeWifiIcon, title: 'WiFi' },
  ETHERNET: { icon: SEHomeEthernetIcon, title: 'Ethernet' },
};

export const MIN_PAGE_HEIGHT = `calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`;

// TODO get this from API when ready
export const HARDWARE_CONNECTIONS: HardwareConnection[] = [
  {
    type: 'ETHERNET',
    enabled: false,
    ip_address: '192.168.1.1',
    connection_status: 'Connected',
    mac_address: 'xx:00:yy:00:zz',
  },
  {
    type: 'WIFI',
    enabled: false,
    ip_address: '192.168.1.1',
    connection_status: 'Connected',
    signal_strength: 'Good',
    ssid: 'Your Network',
    mac_address: 'xx:00:yy:00:zz',
  },
];
